var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seat)?_c('div',[_c('v-circle',{attrs:{"config":{
            x: _vm.x,
            y: _vm.y,
            id: _vm.seat.id,
            radius: 25,
            fill: this.color,
            opacity: 0.8,
            draggable: false,
            scaleX: 1,
            scaleY: 1,
            shadowColor: 'black',
            shadowBlur: 10,
            shadowOpacity: 0.6,
          }},on:{"mousedown":_vm.select,"mouseover":_vm.mouseover}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }